import { render, staticRenderFns } from "./general-info-edit-tab.vue?vue&type=template&id=ba531a3a&scoped=true"
import script from "./general-info-edit-tab.vue?vue&type=script&lang=js"
export * from "./general-info-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./general-info-edit-tab.vue?vue&type=style&index=0&id=ba531a3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba531a3a",
  null
  
)

export default component.exports